import React from "react";
import "./TruckCard.scss";

interface TruckCardProps {
  children: React.ReactNode;
  className?: string;
}

export const TruckCard = ({ children, className }: TruckCardProps) => {
  return (
    <div className={"truck-card" + (className ? " " + className : "")}>
      {children}
    </div>
  );
};

export const TruckCardTitle = ({ children }: TruckCardProps) => {
  return <div className={"truck-card-title mb-3 text-break"}>{children}</div>;
};

export const TruckCardContent = ({ children }: TruckCardProps) => {
  return <div className={"truck-card-content"}>{children}</div>;
};
